import React, { Component } from "react";
import { PageHeader, Spin, Row, Col, message } from "antd";
import { Select } from "antd";
import {
    Form,
    FormItem,
    InputItem,
    TextAreaItem,
    SelectItem,
    InputNumberItem,
    SwitchItem,
    HeaderItem,
    BoxItem,
    DatePickerItem,
} from "../../../../Components/Items";
import { connect } from "react-redux";
import axios from "axios";
import dayjs from "dayjs";

const { Option } = Select || {};

class VerConfigConteo extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        objetoProyecto: null,
        objetoSupervisor: null,
        objetoResponsables: null,
        id: this.props.match.params.id,
    };

    componentDidMount() {
        this.consultarTodo();
    }

    async consultarTodo() {
        this.setState({ loading: true });
        try {
            const res = await axios.post(
                "conteos/selectConfiguracionConteo",
                { empresaId: this.props.empresaId, conteoId: this.state.id },
                { headers: this.props.headersToken }
            );

            if (res.data.success === 2) {
                const c = res.data.conteo || {};

                const proyecto = c.proyectoId;
                const supervisor = c.supervisorId;
                const responsables = c.responsablesIds || [];

                const nombreUsuario = (u) =>
                    u ? `${u.nombre} ${u.apellidoPaterno} ${u.apellidoMaterno}` : "";

                this.setState({
                    objetoProyecto: proyecto
                        ? <Option value={proyecto._id} key={proyecto._id}>{proyecto.nombre}</Option>
                        : null,
                    objetoSupervisor: supervisor
                        ? <Option value={supervisor._id} key={supervisor._id}>{nombreUsuario(supervisor)}</Option>
                        : null,
                    objetoResponsables: responsables.map((r) => (
                        <Option value={r._id} key={r._id}>{nombreUsuario(r)}</Option>
                    )),
                });

                setTimeout(() => {
                    this.formRef.current?.setFieldsValue({
                        nombre:                       c.nombre,
                        descripcion:                  c.descripcion,
                        proyectoId:                   proyecto?._id,
                        supervisorId:                 supervisor?._id,
                        requiereAprobacionSupervisor: c.requiereAprobacionSupervisor ?? false,
                        responsablesIds:              responsables.map((r) => r._id),
                        modoConteo:                   c.modoConteo,
                        estrategiaSeleccionInsumos:   c.estrategiaSeleccionInsumos,
                        ventanaDiasEstrategia:        c.ventanaDiasEstrategia,
                        capacidadPorResponsable:      c.capacidadPorResponsable,
                        reconteosPermitidos:          c.reconteosPermitidos,
                        fechaInicio:                  c.fechaInicio ? dayjs(c.fechaInicio) : null,
                        fechaVigencia:                c.fechaVigencia ? dayjs(c.fechaVigencia) : null,
                    });
                }, 0);
            } else {
                message.error(res.data.message || "No se encontró el conteo");
            }
        } catch {
            message.error("Error de conexión");
        }
        this.setState({ loading: false });
    }

    atras() {
        this.props.history.goBack();
    }

    render() {
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Ver Configuración del Conteo"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />

                <div className="card-background" style={{ paddingTop: 5 }}>
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRef}
                            name="verConfigConteo"
                            layout
                        >
                            <Row gutter={[16, 16]}>
                                {/* Col Izquierda */}
                                <Col span={14} xs={24} sm={24} lg={14} xl={14}>
                                    <HeaderItem>DATOS GENERALES</HeaderItem>
                                    <BoxItem>
                                        <FormItem
                                            name="nombre"
                                            label="Nombre"
                                            margin
                                            labelCol={{ span: 5 }}
                                            wrapperCol={{ span: 19 }}
                                        >
                                            <InputItem disabled placeholder="—" />
                                        </FormItem>

                                        <FormItem
                                            name="descripcion"
                                            label="Descripción"
                                            margin
                                            labelCol={{ span: 5 }}
                                            wrapperCol={{ span: 19 }}
                                        >
                                            <TextAreaItem disabled placeholder="—" rows={3} />
                                        </FormItem>

                                        <FormItem
                                            name="proyectoId"
                                            label="Proyecto"
                                            margin
                                            labelCol={{ span: 5 }}
                                            wrapperCol={{ span: 19 }}
                                        >
                                            <SelectItem disabled allowClear placeholder="—">
                                                {this.state.objetoProyecto}
                                            </SelectItem>
                                        </FormItem>

                                        <FormItem
                                            name="supervisorId"
                                            label="Supervisor"
                                            margin
                                            labelCol={{ span: 5 }}
                                            wrapperCol={{ span: 19 }}
                                        >
                                            <SelectItem disabled allowClear placeholder="—">
                                                {this.state.objetoSupervisor}
                                            </SelectItem>
                                        </FormItem>

                                        <FormItem
                                            name="requiereAprobacionSupervisor"
                                            label="Requiere aprobación"
                                            margin
                                            labelCol={{ span: 5 }}
                                            wrapperCol={{ span: 19 }}
                                            valuePropName="checked"
                                        >
                                            <SwitchItem disabled />
                                        </FormItem>

                                        <FormItem
                                            name="responsablesIds"
                                            label="Responsables"
                                            margin
                                            labelCol={{ span: 5 }}
                                            wrapperCol={{ span: 19 }}
                                        >
                                            <SelectItem mode="multiple" disabled allowClear placeholder="—">
                                                {this.state.objetoResponsables}
                                            </SelectItem>
                                        </FormItem>
                                    </BoxItem>
                                </Col>

                                {/* Col Derecha */}
                                <Col span={10} xs={24} sm={24} lg={10} xl={10}>
                                    <HeaderItem>PARÁMETROS DE CONTEO</HeaderItem>
                                    <BoxItem>
                                        <FormItem
                                            name="modoConteo"
                                            label="Modo de conteo"
                                            margin
                                            labelCol={{ span: 7 }}
                                            wrapperCol={{ span: 17 }}
                                        >
                                            <SelectItem disabled placeholder="—">
                                                <Option value={1}>Ciego</Option>
                                                <Option value={2}>Semi-Ciego</Option>
                                                <Option value={3}>Abierto</Option>
                                            </SelectItem>
                                        </FormItem>

                                        <FormItem
                                            name="estrategiaSeleccionInsumos"
                                            label="Estrategia"
                                            margin
                                            labelCol={{ span: 7 }}
                                            wrapperCol={{ span: 17 }}
                                        >
                                            <SelectItem disabled placeholder="—">
                                                <Option value={1}>Más rotación</Option>
                                                <Option value={2}>Menos rotación</Option>
                                                <Option value={3}>Aleatorio (Alguna vez existente)</Option>
                                                <Option value={4}>Aleatorio (Todos)</Option>
                                                <Option value={5}>Todos</Option>
                                                <Option value={6}>Todos con existencia</Option>
                                            </SelectItem>
                                        </FormItem>

                                        <FormItem
                                            name="ventanaDiasEstrategia"
                                            label="Ventana (días)"
                                            margin
                                            labelCol={{ span: 7 }}
                                            wrapperCol={{ span: 17 }}
                                        >
                                            <InputNumberItem disabled placeholder="—" min={0} />
                                        </FormItem>

                                        <FormItem
                                            noStyle
                                            shouldUpdate={(prev, curr) => prev.estrategiaSeleccionInsumos !== curr.estrategiaSeleccionInsumos}
                                        >
                                            {({ getFieldValue }) => {
                                                const estrategia = getFieldValue("estrategiaSeleccionInsumos");
                                                if (estrategia === 5 || estrategia === 6) return null;
                                                return (
                                                    <FormItem
                                                        name="capacidadPorResponsable"
                                                        label="Capacidad / responsable"
                                                        margin
                                                        labelCol={{ span: 7 }}
                                                        wrapperCol={{ span: 17 }}
                                                    >
                                                        <InputNumberItem disabled placeholder="—" min={1} />
                                                    </FormItem>
                                                );
                                            }}
                                        </FormItem>

                                        <FormItem
                                            name="reconteosPermitidos"
                                            label="Reconteos permitidos"
                                            margin
                                            labelCol={{ span: 7 }}
                                            wrapperCol={{ span: 17 }}
                                        >
                                            <InputNumberItem disabled placeholder="—" min={0} />
                                        </FormItem>
                                    </BoxItem>

                                    <HeaderItem>PROGRAMACIÓN</HeaderItem>
                                    <BoxItem>
                                        <FormItem
                                            name="fechaInicio"
                                            label="Fecha Inicio"
                                            margin
                                            labelCol={{ span: 7 }}
                                            wrapperCol={{ span: 17 }}
                                        >
                                            <DatePickerItem
                                                disabled
                                                placeholder="—"
                                                style={{ width: "100%" }}
                                            />
                                        </FormItem>
                                        <FormItem
                                            name="fechaVigencia"
                                            label="Fecha Vigencia"
                                            margin
                                            labelCol={{ span: 7 }}
                                            wrapperCol={{ span: 17 }}
                                        >
                                            <DatePickerItem
                                                disabled
                                                placeholder="—"
                                                style={{ width: "100%" }}
                                            />
                                        </FormItem>
                                    </BoxItem>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(VerConfigConteo);
